import RotarAgenciaPage from "./RotarAgenciaPage";

export {RotarAgenciaPage}
export default RotarAgenciaPage
